import { buildingSociety } from './building/AT';
import { currentAccount } from './current/AT';
import { saving } from './saving/AT';
import type { ProductsFeatures } from '../ProductFeatures';

export const productsFeaturesAT: ProductsFeatures = {
    ...buildingSociety,
    ...currentAccount,
    ...saving,
    accounts: {
        ownResources: {
            enabled: false,
            _description: 'Enables showing ownResources as an account main amount.',
        },
        instantPaymentLimitChange: {
            enabled: false,
            _description: 'Enables accounts instant limit display and limit change feature.',
        },
        regularPaymentLimitChange: {
            enabled: false,
            _description:
                'Enables accounts regular payment limit display and limit change feature.',
        },
    },
    additionalSettings: {
        enabled: false,
        _description: 'Adds the additional settings card to profile administration',
    },
    specialFeeStatement: {
        enabled: false,
        _description: 'Enables the special fee for statements cell in statements list',
    },
    dropLegacyAccounts: {
        enabled: false,
        _description: 'Drop legacy archive HRK accounts on standard fetch',
    },
    showOverdraftRichStripe: {
        enabled: true,
        _description: 'Controls to show the rich stripe for current account on history page',
    },
    relyOnPAPIDataForCurrentAccounts: {
        enabled: false,
        _description: 'Relies on data provided by PAPI endpoint for current accounts',
    },
    relyOnPAPIDataForSavingAccounts: {
        enabled: false,
        _description: 'Relies on data provided by PAPI endpoint for saving accounts',
    },
    relyOnPAPIDataForLoanAccounts: {
        enabled: false,
        _description: 'Relies on data provided by PAPI endpoint for loan accounts',
    },
    product: {
        papiCustomization: {
            enabled: false,
            _description: 'Enables usage of PAPI customizations endpoint.',
        },
    },
};
